<template>
    <section class="section">
        <div class="title">隐私设置</div>
        <div class="privacy-box df">
            <div class="privacy-name">我的收藏</div>
            <div @click="change('collect_show')" :class="`switch${collect_show ? ' checked' : ''}`">
                <i class="switch-icon"></i>
            </div>
            <div class="switch-label">{{collect_show ? '公开' : '隐藏'}}</div>
        </div>

        <div class="privacy-box df">
            <div class="privacy-name">最近赞过的视频</div>
            <div @click="change('like_show')" :class="`switch${like_show ? ' checked' : ''}`">
                <i class="switch-icon"></i>
            </div>
            <div class="switch-label">{{like_show ? '公开' : '隐藏'}}</div>
        </div>
    </section>
</template>

<script>
    export default {
        data: () => ({
            collect_show: true,
            like_show: true,
            is_updating: true,
        }),
        computed: {
            id() {
                return +this.$route.params.id;
            },
            user() {
                return this.$store.state.user;
            },
            uid() {
                return this.user.id;
            },
        },
        methods: {
            change(e) {
                if (this.is_updating) return;
                this.is_updating = true;
                this[e] = !this[e];
                let params = {};
                params[e] = +this[e];
                this.api.patch('users/update', params).then(e => {
                    this.is_updating = false;
                }, e => {
                    this[e] = !this[e];
                    this.is_updating = false;
                    this.alert.err(e.message);
                })
            }
        },
        beforeMount() {
            this.api.get('users/privacies').then(e => {
                this.collect_show = e.collect_show;
                this.like_show = e.like_show;
                this.is_updating = false;
            }, e => {
                this.alert.err(e.message);
            })
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/space/setting.css";
</style>


// WEBPACK FOOTER //
// src/views/space/Setting.vue